<template>
  <a-layout>
    <a-divider orientation="left">{{ $t('business.label.customerCategory') }}</a-divider>
    <a-spin :spinning="loading">
      <a-directory-tree :selectedKeys="selectedKeys" :treeData="treeData" @select="onSelected"/>
    </a-spin>
  </a-layout>
</template>
<script>
  import {findOne} from '@/api/Api'

  export default {
    name: 'ValidConfigTree',
    data() {
      return {
        treeData: [],
        selectedKeys: [],
        e: null,
        loading: false
      }
    },
    mounted() {
      this.getData()
    },
    methods: {
      onSelected(selectedKeys, e) {
        this.selectedKeys = selectedKeys
        this.e = e
        this.$emit('onSelected', this.e.node.value)
      },
      getData() {
        this.loading = true
        findOne('fieldFactory', {no: 'CUSTOMER_CLASSIFICATION'}).then(res => {
          if (res.success) {
            this.treeData = []
            res.result.dictionaries.forEach(item => {
              this.treeData.push({title: item.name, key: item.id, leaf: true, value: {id: item.id, name: item.name}})
            })
          }
        }).finally(() => {
          this.loading = false
        })
      },
      refresh() {
        this.loading = true
        findOne('fieldFactory', {no: 'CUSTOMER_CLASSIFICATION'}).then(res => {
          if (res.success) {
            this.treeData = []
            res.result.dictionaries.forEach(item => {
              this.treeData.push({title: item.name, key: item.id, leaf: true, value: {id: item.id, name: item.name}})
            })
            this.$emit('onSelected', this.e.node.value)
          }
        }).finally(() => {
          this.loading = false
        })
      }
    }
  }
</script>

<style scoped>

</style>